import React, { Fragment } from 'react';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import { isFilterMenuOpened } from "../../selectors/entities/ui"
import {
    getAvailableHexColorsExtended,
    getAvailableStylesColorsExtended,
    getAvailableTextColorsExtended,
    getAvailablePatternsExtended,
    getAvailableWeavesExtended,
    getActiveFabricFilter,
} from '../../selectors/entities/filters';
import {
    toggleFilterMenu,
    applyFilter,
    clearFilter,
    screenResize,
} from "../../actions/ui"

import FabricFilters from '../FabricFilters';
import ProductList from '../ProductList';
import { CatalogFooter } from './Footer';
import RitIconButton from '../RitIconButton';
import FilterIcon from '../ui/Checkbox/FilterIcon'

class CatalogPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    UNSAFE_componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
        this.handleWindowSizeChange()
    }

    handleWindowSizeChange = () => {
        const { actions: { screenResize } } = this.props;
        store.dispatch(screenResize(window.innerWidth));
    };

    componentDidMount() {
        const { preset, actions: {applyFilter} } = this.props;

        if(preset){
            const filterType = 'styles';
            applyFilter(filterType, preset, true)
        }

        document.querySelector('.b-layout').style.height = 'auto';
    }

    componentWillUnmount() {
        document.querySelector('.b-layout').style.height = '';
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }

    handleFilterChange = (filterType, filterValue, checked) => {
        this.props.actions.applyFilter(filterType, filterValue, checked)
    }
    
    handleFilterClear = async (filterType, filterValue, checked) => {
        this.props.actions.clearFilter(filterType, filterValue, checked)
    }

    handleToggleFilterMenu = (e) => {
        e.preventDefault();
        this.props.actions.toggleFilterMenu()
    }

    shouldComponentUpdate = (props, state) => {
        return this.props.activeFabricFilters !== props.activeFabricFilters || 
        this.props.isMobile !== props.isMobile ||
        this.props.filterMenuOpened !== props.filterMenuOpened;
    }

    render() {
        const {
            filterMenuOpened,
            activeFabricFilters,
            colorsHex,
            colorText,
            stylesText,
            patternsText,
            weavesText,
            isMobile,
        } = this.props

        const filterMenuOpenState = isMobile ? filterMenuOpened : true;
        return (
            <Fragment>
                <div className="b-rit-catalog">
                    {isMobile && <div className="b-rit-catalog__modile-menu">
                        <RitIconButton
                            labelClass='b-rit-catalog__filter-button'
                            onClick={this.handleToggleFilterMenu}
                        >
                            <FilterIcon size={24}/>
                        </RitIconButton>
                    </div>}
                    <div className="b-rit-catalog__filter">
                        <FabricFilters
                            isOpened={filterMenuOpenState}
                            activeFabricFilters={activeFabricFilters}
                            availableColorsText={colorText}
                            availableColorsHex={colorsHex}
                            availableStylesText={stylesText}
                            availablePatternsText={patternsText}
                            availableWeavesText={weavesText}
                            onFilterChange={this.handleFilterChange}
                            onFilterClear={this.handleFilterClear}
                            isMobile={isMobile}
                            onShowFilterClick={this.handleToggleFilterMenu}
                            type='catalog'
                        />
                    </div>
                    <div className="b-rit-catalog__product-list">
                        <ProductList />
                    </div>
                </div>
            </Fragment>
        )
    }
}

CatalogPage.propTypes = {
    preset: PropTypes.string,
    filterMenuOpened: PropTypes.bool.isRequired,
    activeFabricFilters: PropTypes.object.isRequired,
    colorsHex: PropTypes.array.isRequired,
    colorText: PropTypes.array.isRequired,
    stylesText: PropTypes.array.isRequired,
    patternsText: PropTypes.array.isRequired,
    weavesText: PropTypes.array.isRequired,
    isMobile: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
    const filterMenuOpened = isFilterMenuOpened(state)
    const activeFabricFilters = getActiveFabricFilter(state)
    const colorsHex = getAvailableHexColorsExtended(state);
    const colorText = getAvailableTextColorsExtended(state);
    const stylesText = getAvailableStylesColorsExtended(state);
    const patternsText = getAvailablePatternsExtended(state);
    const weavesText = getAvailableWeavesExtended(state);
    const isMobile = state.ui.isMobile;

    return {
        ...ownProps,
        filterMenuOpened,
        activeFabricFilters,
        colorsHex,
        colorText,
        stylesText,
        patternsText,
        weavesText,
        isMobile,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            toggleFilterMenu,
            applyFilter,
            clearFilter,
            screenResize,
        }, dispatch)
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(CatalogPage));
